import { render, staticRenderFns } from "./RecordingsView.vue?vue&type=template&id=1fd49234&scoped=true&"
import script from "./RecordingsView.vue?vue&type=script&lang=ts&"
export * from "./RecordingsView.vue?vue&type=script&lang=ts&"
import style0 from "./RecordingsView.vue?vue&type=style&index=0&id=1fd49234&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd49234",
  null
  
)

export default component.exports